module.exports = new __parcel__URL__("login_poster_4.d813f3e5.png").toString();